import { NavLink } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";
import styles from "./styles.module.scss";
import { getDaysUntilNextSubscription } from "../../../helpers";

export const SubscriptionToast = ({ activeSubscription = {} }) => {
  const noOfDays = getDaysUntilNextSubscription(
    activeSubscription?.next_subscription_date,
  );

  return (
    <>
      {activeSubscription?.pricing?.tier?.name === "Free" ? (
        <div className={styles.subscriptionToast}>
          <span>
            Your free trial ends in {noOfDays} days. Kindly{" "}
            <NavLink
              to={pathConstants.APP_SUBSCRIPTION_PLAN}
              className={"purple--text"}
              style={{ textDecoration: "underline" }}
            >
              Upgrade Now
            </NavLink>{" "}
            to continue enjoying full access.
          </span>
        </div>
      ) : activeSubscription && noOfDays <= 10 ? (
        <div className={styles.subscriptionToast}>
          {" "}
          <span>
            Your subscription expires in {noOfDays} days. For uninterrupted
            access, kindly{" "}
            <NavLink
              to={pathConstants.APP_SUBSCRIPTION_PLAN}
              className={"purple--text"}
              style={{ textDecoration: "underline" }}
            >
              Renew Now
            </NavLink>
          </span>
        </div>
      ) : null}
    </>
  );
};
